document.addEventListener('DOMContentLoaded',()=>{const isRTL=document.documentElement.getAttribute('dir')==='rtl';if(!isRTL)return;document.querySelectorAll('input, textarea').forEach((el)=>{if(!el.matches('[type="email"], [type="tel"], [type="number"], [data-ltr]')){el.setAttribute('dir','rtl')}});const alignCards=()=>{document.querySelectorAll(['.collection-list .card__information','.collection-list .card__heading','.collection-list .card__heading a','.collection-card-wrapper .card__information','.collection-card-wrapper .card__heading','.collection-card-wrapper .card__heading a','.product-card-wrapper .card__information','.product-card-wrapper .card__heading','.product-card-wrapper .card__heading a','.grid .card__information','.grid .card__heading','.grid .card__heading a','.slider .card__information','.slider .card__heading','.slider .card__heading a','.card-wrapper .card__information','.card-wrapper .card__heading','.card-wrapper .card__heading a','.card-information','.card-information *'].join(',')).forEach((el)=>{el.style.setProperty('direction','rtl','important');el.style.setProperty('text-align','right','important')})};alignCards();window.addEventListener('load',alignCards,{once:!0});const cleanArabicCartLabels=()=>{if(!window.location.pathname.includes('/cart'))return;const setText=(selector,text)=>{document.querySelectorAll(selector).forEach((el)=>{if(/^\?+(\s+\?+)*$/.test(el.textContent.trim())||el.textContent.includes('????')){el.textContent=text}})};setText('h1.title--primary','سلتك');setText('.cart__empty-text','سلتك فارغة');setText('.title-wrapper-with-link .underlined-link','متابعة التسوق');setText('.cart-items thead th:nth-child(1)','المنتج');setText('.cart-items thead th:nth-child(2)','الإجمالي');setText('.cart-items thead th:nth-child(3)','الكمية');setText('.cart-items thead th:nth-child(4)','الإجمالي');setText('label[for="Cart-note"]','تعليمات خاصة للطلب');setText('.totals__total','الإجمالي التقديري');setText('.cart__checkout-button','إتمام الشراء');document.querySelectorAll('.tax-note').forEach((el)=>{if(el.textContent.includes('????')){el.textContent='الضرائب مشمولة. تُحسب الخصومات ورسوم الشحن عند إتمام الطلب.'}})};cleanArabicCartLabels();window.addEventListener('load',cleanArabicCartLabels,{once:!0});const localizeFooterLinks=()=>{const path=window.location.pathname||'';const localePrefix=path.startsWith('/ar')?'/ar':path.startsWith('/ru')?'/ru':'';if(!localePrefix)return;document.querySelectorAll('footer a[href^="/"]').forEach((link)=>{const href=link.getAttribute('href')||'';if(href==='/'||href.startsWith('/ar')||href.startsWith('/ru')||href.startsWith('/cdn/')||href.startsWith('/cart')||href.startsWith('/account')||href.startsWith('/search')){if(href==='/')link.setAttribute('href',localePrefix);return}
link.setAttribute('href',`${localePrefix}${href}`)})};localizeFooterLinks();window.addEventListener('load',localizeFooterLinks,{once:!0});if(window.location.pathname.includes('/cart')){let cartLabelFixAttempts=0;const cartLabelFixTimer=window.setInterval(()=>{cleanArabicCartLabels();localizeFooterLinks();cartLabelFixAttempts+=1;if(cartLabelFixAttempts>=30){window.clearInterval(cartLabelFixTimer)}},250)}
const observer=new MutationObserver(()=>{window.requestAnimationFrame(()=>{alignCards();cleanArabicCartLabels();localizeFooterLinks()})});observer.observe(document.body,{childList:!0,subtree:!0})})

/* 2026-07-25: repair two-row RTL slider paging. */
;(() => {
  if (document.documentElement.dir !== 'rtl') return;

  const selector = [
    ".shopify-section[id*='__collection_list_'] slider-component",
    ".shopify-section[id*='__featured-collection'] slider-component",
  ].join(',');

  const repair = (component) => {
    const slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return;

    const items = Array.from(slider.children).filter(
      (item) => item.id && item.id.startsWith('Slide-') && item.clientWidth > 0
    );
    if (items.length < 2) return;

    const first = items[0];
    const nextPosition = items.find(
      (item) => Math.abs(item.offsetLeft - first.offsetLeft) > 1
    );
    if (!nextPosition) return;

    const signedStep = nextPosition.offsetLeft - first.offsetLeft;
    const step = Math.abs(signedStep);
    if (!Number.isFinite(step) || step <= 0) return;

    const startGap = Math.max(
      0,
      slider.clientWidth - (first.offsetLeft + first.clientWidth)
    );
    const slidesPerPage = Math.max(
      1,
      Math.floor((slider.clientWidth - startGap) / step)
    );

    component.sliderItemsToShow = items;
    component.sliderItemOffset = signedStep;
    component.slidesPerPage = slidesPerPage;
    component.totalPages = Math.max(1, items.length - slidesPerPage + 1);
    component.isSlideVisible = (element, offset = 0) => {
      const sliderRect = slider.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      return (
        elementRect.left >= sliderRect.left + offset - 1
        && elementRect.right <= sliderRect.right - offset + 1
      );
    };
    component.update();
  };

  const enhance = (component) => {
    if (component.dataset.djRtlSliderFixed === 'true') {
      repair(component);
      return;
    }
    component.dataset.djRtlSliderFixed = 'true';
    component.initPages = () => repair(component);
    repair(component);
  };

  const run = () => document.querySelectorAll(selector).forEach(enhance);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('load', run, { once: true });
})();
